export default __webpack_public_path__ + "static/media/dining-LP.2afaaf8b.svg";